import {
  RECEIVED_PRINTER_LIST, ERROR_ON_GETTING_PRINTER_LIST, START_FETCHING_PRINTER_LIST,
  UPDATE_PRINTER_STATE, UPDATE_TOGGLE_LIST_OF_PRINTER_STATUS
} from "../actions/types";

const initState = {
  printerIds: [],
  togglesOfPrinterStatusItems: [],
  loading: true,
  error: null,
  isBarUpdaterEstablished: false
};

const printerStatusReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case START_FETCHING_PRINTER_LIST:
      return { ...state, loading: true }
    case RECEIVED_PRINTER_LIST:
      return { ...state, loading: false, ...payload }
    case ERROR_ON_GETTING_PRINTER_LIST:
      return { ...state, loading: false, ...payload }
    case UPDATE_PRINTER_STATE:
      const newState = { ...state };
      for (let printerId in payload) {
        newState[printerId] = { ...newState[printerId], ...payload[printerId] }
      }
      return newState;
    case UPDATE_TOGGLE_LIST_OF_PRINTER_STATUS:
      return { ...state, ...payload }
    default:
      return state;
  }
}

export default printerStatusReducer;


// WEBPACK FOOTER //
// ./src/reducers/printer-status-reducer.js